import { Guid, EMPTY_GUID } from "../types/Guid";
export namespace Cnt.ThreeDeeCrate.SDK {
export enum ContainerType { 
	Container = 0,
	Object = 1,
	SearchContainer = 2,
}

export enum GenerationStatusType { 
	ToBeGenerated = 0,
	Queued = 1,
	CreatingReference = 2,
	GeneratingMesh = 3,
	GeneratingDiffuse = 4,
	GeneratingNormal = 5,
	UVUnwrapping = 6,
	GeneratingThumbnail = 7,
	UploadingModel = 8,
	Done = 9,
}

export enum GraphicalStyleType { 
	Stylized = 0,
	Standard = 1,
}

export enum ModelStatusType { 
	IsNotLoggedIn = 0,
	NotPurchased = 1,
	Purchased = 2,
}

export enum SubscriptionType { 
	NotSubscribed = 0,
	PremiumModelSubscription = 1,
}

export enum VisibilityType { 
	Private = 0,
	Public = 1,
}


/**
 * Represents an Auto-generated model for AuthResponse.
 */
export interface IAuthResponse { 
    Token?: string | undefined;
    User: UserDTO | undefined;
}

export class AuthResponse implements IAuthResponse { 
    public Token: string | undefined;
    public User: UserDTO | undefined;

    constructor(init: Partial<IAuthResponse>) { 
        this.Token = init.Token;
        this.User = init.User;
    }
}

/**
 * Represents an Auto-generated model for CheckHasPurchasedRequestDTO.
 */
export interface ICheckHasPurchasedRequestDTO { 
    Url?: string | undefined;
    ContainerId: Guid | undefined;
}

export class CheckHasPurchasedRequestDTO implements ICheckHasPurchasedRequestDTO { 
    public Url: string | undefined;
    public ContainerId: Guid | undefined;

    constructor(init: Partial<ICheckHasPurchasedRequestDTO>) { 
        this.Url = init.Url;
        this.ContainerId = init.ContainerId;
    }
}

/**
 * Represents an Auto-generated model for CheckHasPurchasedResultDTO.
 */
export interface ICheckHasPurchasedResultDTO { 
    HasPurchased: boolean | undefined;
}

export class CheckHasPurchasedResultDTO implements ICheckHasPurchasedResultDTO { 
    public HasPurchased: boolean | undefined;

    constructor(init: Partial<ICheckHasPurchasedResultDTO>) { 
        this.HasPurchased = init.HasPurchased;
    }
}

/**
 * Represents an Auto-generated model for ContainerDTO.
 */
export interface IContainerDTO { 
    Id: Guid | undefined;
    ParentId?: Guid | undefined;
    Name?: string | undefined;
    Description?: string | undefined;
    ContainerType: ContainerType | undefined;
    Visibility: VisibilityType | undefined;
    GraphicalStyle: GraphicalStyleType | undefined;
}

export class ContainerDTO implements IContainerDTO { 
    public Id: Guid | undefined;
    public ParentId: Guid | undefined;
    public Name: string | undefined;
    public Description: string | undefined;
    public ContainerType: ContainerType | undefined;
    public Visibility: VisibilityType | undefined;
    public GraphicalStyle: GraphicalStyleType | undefined;

    constructor(init: Partial<IContainerDTO>) { 
        this.Id = init.Id;
        this.ParentId = init.ParentId;
        this.Name = init.Name;
        this.Description = init.Description;
        this.ContainerType = init.ContainerType;
        this.Visibility = init.Visibility;
        this.GraphicalStyle = init.GraphicalStyle;
    }
}

/**
 * Represents an Auto-generated model for ContainerModelDTO.
 */
export interface IContainerModelDTO { 
    Model: ModelDTO | undefined;
    Container: ContainerDTO | undefined;
}

export class ContainerModelDTO implements IContainerModelDTO { 
    public Model: ModelDTO | undefined;
    public Container: ContainerDTO | undefined;

    constructor(init: Partial<IContainerModelDTO>) { 
        this.Model = init.Model;
        this.Container = init.Container;
    }
}

/**
 * Represents an Auto-generated model for CreateUpdateModelDTO.
 */
export interface ICreateUpdateModelDTO { 
    Id: Guid | undefined;
    ParentId: Guid | undefined;
    Price: number | undefined;
    Name?: string | undefined;
    Description?: string | undefined;
    Visibility: VisibilityType | undefined;
    GraphicalStyle: GraphicalStyleType | undefined;
}

export class CreateUpdateModelDTO implements ICreateUpdateModelDTO { 
    public Id: Guid | undefined;
    public ParentId: Guid | undefined;
    public Price: number | undefined;
    public Name: string | undefined;
    public Description: string | undefined;
    public Visibility: VisibilityType | undefined;
    public GraphicalStyle: GraphicalStyleType | undefined;

    constructor(init: Partial<ICreateUpdateModelDTO>) { 
        this.Id = init.Id;
        this.ParentId = init.ParentId;
        this.Price = init.Price;
        this.Name = init.Name;
        this.Description = init.Description;
        this.Visibility = init.Visibility;
        this.GraphicalStyle = init.GraphicalStyle;
    }
}

/**
 * Represents an Auto-generated model for ModelDTO.
 */
export interface IModelDTO { 
    Id: Guid | undefined;
    StripePriceId?: string | undefined;
    Price: number | undefined;
    ThumbnailUrl?: string | undefined;
    ProductionZipUrl?: string | undefined;
    FileNames?: string | undefined;
    GenerationStatus: GenerationStatusType | undefined;
    Visibility: VisibilityType | undefined;
    CreationDate: string | undefined;
    UpdatedDate: string | undefined;
    IsRecommended: boolean | undefined;
}

export class ModelDTO implements IModelDTO { 
    public Id: Guid | undefined;
    public StripePriceId: string | undefined;
    public Price: number | undefined;
    public ThumbnailUrl: string | undefined;
    public ProductionZipUrl: string | undefined;
    public FileNames: string | undefined;
    public GenerationStatus: GenerationStatusType | undefined;
    public Visibility: VisibilityType | undefined;
    public CreationDate: string | undefined;
    public UpdatedDate: string | undefined;
    public IsRecommended: boolean | undefined;

    constructor(init: Partial<IModelDTO>) { 
        this.Id = init.Id;
        this.StripePriceId = init.StripePriceId;
        this.Price = init.Price;
        this.ThumbnailUrl = init.ThumbnailUrl;
        this.ProductionZipUrl = init.ProductionZipUrl;
        this.FileNames = init.FileNames;
        this.GenerationStatus = init.GenerationStatus;
        this.Visibility = init.Visibility;
        this.CreationDate = init.CreationDate;
        this.UpdatedDate = init.UpdatedDate;
        this.IsRecommended = init.IsRecommended;
    }
}

/**
 * Represents an Auto-generated model for ResultUrlDTO.
 */
export interface IResultUrlDTO { 
    Url?: string | undefined;
}

export class ResultUrlDTO implements IResultUrlDTO { 
    public Url: string | undefined;

    constructor(init: Partial<IResultUrlDTO>) { 
        this.Url = init.Url;
    }
}

/**
 * Represents an Auto-generated model for SearchRequestDTO.
 */
export interface ISearchRequestDTO { 
    SearchName?: string | undefined;
    GraphicalStyle: GraphicalStyleType | undefined;
}

export class SearchRequestDTO implements ISearchRequestDTO { 
    public SearchName: string | undefined;
    public GraphicalStyle: GraphicalStyleType | undefined;

    constructor(init: Partial<ISearchRequestDTO>) { 
        this.SearchName = init.SearchName;
        this.GraphicalStyle = init.GraphicalStyle;
    }
}

/**
 * Represents an Auto-generated model for UserDTO.
 */
export interface IUserDTO { 
    Id: Guid | undefined;
    Name?: string | undefined;
    Email?: string | undefined;
    ProfilePicture?: string | undefined;
    IsAdmin: boolean | undefined;
    Subscription: SubscriptionType | undefined;
}

export class UserDTO implements IUserDTO { 
    public Id: Guid | undefined;
    public Name: string | undefined;
    public Email: string | undefined;
    public ProfilePicture: string | undefined;
    public IsAdmin: boolean | undefined;
    public Subscription: SubscriptionType | undefined;

    constructor(init: Partial<IUserDTO>) { 
        this.Id = init.Id;
        this.Name = init.Name;
        this.Email = init.Email;
        this.ProfilePicture = init.ProfilePicture;
        this.IsAdmin = init.IsAdmin;
        this.Subscription = init.Subscription;
    }
}

 /**
 * Auto-generated client for the Auth controller.
 */
export class Auth {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async SynchronizeUser( ): Promise<AuthResponse> {
        const url = `${this.baseUrl}/api/Auth/SynchronizeUser`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated client for the Container controller.
 */
export class Container {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async GetAllContainers(graphicalStyle: GraphicalStyleType ): Promise<ContainerDTO[]> {
        const url = `${this.baseUrl}/api/Container/GetAllContainers/` + graphicalStyle + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetContainers(containerId: Guid, pageIndex: number, pageSize: number, graphicalStyle: GraphicalStyleType ): Promise<ContainerDTO[]> {
        const url = `${this.baseUrl}/api/Container/GetContainers/` + containerId + `/` + pageIndex + `/` + pageSize + `/` + graphicalStyle + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async Move(containerId: Guid, parentId: Guid ): Promise<ContainerDTO> {
        const url = `${this.baseUrl}/api/Container/Move/` + containerId + `/` + parentId + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async Search(searchRequestDTO: SearchRequestDTO ): Promise<ContainerDTO[]> {
        const url = `${this.baseUrl}/api/Container/Search`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(searchRequestDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async Create(containerDTO: ContainerDTO ): Promise<ContainerDTO> {
        const url = `${this.baseUrl}/api/Container/Create`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(containerDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async Update(containerDTO: ContainerDTO ): Promise<ContainerDTO> {
        const url = `${this.baseUrl}/api/Container/Update`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(containerDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async ReadById(containerId: Guid ): Promise<ContainerDTO> {
        const url = `${this.baseUrl}/api/Container/ReadById/` + containerId + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async ReadByParentAndName(parentId: Guid, name: string ): Promise<ContainerDTO> {
        const url = `${this.baseUrl}/api/Container/ReadByParentAndName/` + parentId + `/` + name + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated client for the Model controller.
 */
export class Model {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async GetToBeGenerated( ): Promise<ModelDTO[]> {
        const url = `${this.baseUrl}/api/Model/GetToBeGenerated`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetGeneratingModel( ): Promise<ContainerModelDTO> {
        const url = `${this.baseUrl}/api/Model/GetGeneratingModel`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async UpdateVisibility(id: Guid, visibility: VisibilityType ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/UpdateVisibility/` + id + `/` + visibility + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async UpdateStatus(id: Guid, status: GenerationStatusType ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/UpdateStatus/` + id + `/` + status + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetLatestModels(count: number ): Promise<ContainerDTO[]> {
        const url = `${this.baseUrl}/api/Model/GetLatestModels/` + count + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetRecommendedModels(count: number ): Promise<ContainerDTO[]> {
        const url = `${this.baseUrl}/api/Model/GetRecommendedModels/` + count + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async SetRecommendation(id: Guid, isRecommended: boolean ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/SetRecommendation/` + id + `/` + isRecommended + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async UpdateThumbnail(modelDTO: ModelDTO ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/UpdateThumbnail`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(modelDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async Update(modelDTO: ModelDTO ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/Update`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(modelDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CreateOrUpdate(createUpdateModelDTO: CreateUpdateModelDTO ): Promise<ContainerModelDTO> {
        const url = `${this.baseUrl}/api/Model/CreateOrUpdate`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(createUpdateModelDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async ReadById(id: Guid ): Promise<ModelDTO> {
        const url = `${this.baseUrl}/api/Model/ReadById/` + id + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetModelInformation(containerId: Guid ): Promise<ContainerModelDTO> {
        const url = `${this.baseUrl}/api/Model/GetModelInformation/` + containerId + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CheckUserModelStatus(checkHasPurchasedRequestDTO: CheckHasPurchasedRequestDTO ): Promise<ModelStatusType> {
        const url = `${this.baseUrl}/api/Model/CheckUserModelStatus`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(checkHasPurchasedRequestDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CheckHasPurchased(checkHasPurchasedRequestDTO: CheckHasPurchasedRequestDTO ): Promise<CheckHasPurchasedResultDTO> {
        const url = `${this.baseUrl}/api/Model/CheckHasPurchased`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(checkHasPurchasedRequestDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetDownloadUrl(containerId: Guid ): Promise<ResultUrlDTO> {
        const url = `${this.baseUrl}/api/Model/GetDownloadUrl/` + containerId + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async GetLiteDownloadUrl(containerId: Guid ): Promise<ResultUrlDTO> {
        const url = `${this.baseUrl}/api/Model/GetLiteDownloadUrl/` + containerId + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated client for the Users controller.
 */
export class Users {
    private baseUrl: string;

    constructor(baseUrl: string) {
        this.baseUrl = baseUrl;
    }

    public async GetUser(id: Guid ): Promise<UserDTO> {
        const url = `${this.baseUrl}/api/Users/GetUser/` + id + ``

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'GET',
            headers: headers, 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
    public async CreateUser(userDTO: UserDTO ): Promise<UserDTO> {
        const url = `${this.baseUrl}/api/Users/CreateUser`

        const idToken = localStorage.getItem("access_token") ?? "";

        // Construct the request options
        const headers: HeadersInit = {
            'Content-Type': 'application/json',
            // body will be added below
        };
        if (idToken) {
            headers["Authorization"] = `Bearer ${idToken}`;
        }

        // Construct the request options
        const requestOptions: RequestInit = {
            method: 'POST',
            headers: headers, 
            body: JSON.stringify(userDTO) 
        };

        // Perform the fetch request
        const response = await fetch(url, requestOptions);

        // Throw an error if the response is not successful
        if (!response.ok) throw new Error(await response.text());

        // Return the parsed response
        return await response.json();
    } 
}

 /**
 * Auto-generated API client.
 */
export class Api {

    public auth: Auth;
    public container: Container;
    public model: Model;
    public users: Users;

    constructor(baseUrl: string) { 
        this.auth = new Auth(baseUrl);
        this.container = new Container(baseUrl);
        this.model = new Model(baseUrl);
        this.users = new Users(baseUrl);
    }
}


}
